import React, { useContext } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { IUseApiProps } from '../useApi';
import ClPropertiesCls from './ClPropertiesCls';
import { OrbUserContext } from '../OrbUserContext';

export interface IClPropertiesProps extends IUseApiProps, IWithErrorHandlingProps {
}

const ClProperties = (props: IClPropertiesProps) => {
    const { userPermissions } = useContext(OrbUserContext);
    return (
        <ErrorBoundary>
            <ClPropertiesCls
                userPermissions={userPermissions}
                {...props}
            />
        </ErrorBoundary>
    );
};

export default withErrorHandling(ClProperties);
